import { RequestRoutes } from '@constants/requestRoutes';
import { apiHeader, headerJson } from '@helpers/commonHeaders';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { blackoutTag } from '@constants/apiTags';

export const blackoutAPI = createApi({
  reducerPath: 'blackoutAPI',
  tagTypes: [blackoutTag],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API_URL,
    prepareHeaders: apiHeader,
  }),
  endpoints: (build) => ({
    // POST: Add new physician blackout
    addPhysicianBlackout: build.mutation({
      query: ({ acceptTerms, ...blackout }) => ({
        url: `${RequestRoutes.Blackout}${RequestRoutes.Physician}`,
        headers: headerJson,
        method: 'POST',
        body: blackout,
      }),
      invalidatesTags: [blackoutTag],
    }),

    addLocationBlackout: build.mutation({
      query: ({ acceptTerms, ...blackout }) => ({
        url: `${RequestRoutes.Blackout}${RequestRoutes.Locations}`,
        headers: headerJson,
        method: 'POST',
        body: blackout,
      }),
      invalidatesTags: [blackoutTag],
    }),

    // GET: Fetch all physician blackouts
    fetchPhysicianBlackouts: build.query({
      query: (physicianId: string) => ({
        url: `${RequestRoutes.Blackout}${RequestRoutes.Physician}?physicianId=${physicianId}`,
        headers: headerJson,
        method: 'GET',
      }),
      providesTags: [blackoutTag],
    }),

    fetchLocationBlackouts: build.query({
      query: (locationId: string) => ({
        url: `${RequestRoutes.Blackout}${RequestRoutes.Locations}?locationId=${locationId}`,
        headers: headerJson,
        method: 'GET',
      }),
      providesTags: [blackoutTag],
    }),

    updatePhysicianBlackout: build.mutation({
      query: ({ id, physicianId, locationId, acceptTerms, ...blackoutToSubmit }) => ({
        url: `${RequestRoutes.Blackout}${RequestRoutes.Physician}?blackoutId=${id}`,
        headers: headerJson,
        method: 'PATCH',
        body: blackoutToSubmit,
      }),
      invalidatesTags: [blackoutTag],
    }),

    updateLocationBlackout: build.mutation({
      query: ({ id, locationId, physicianId, acceptTerms, ...blackoutToSubmit }) => ({
        url: `${RequestRoutes.Blackout}${RequestRoutes.Locations}?blackoutId=${id}`,
        headers: headerJson,
        method: 'PATCH',
        body: blackoutToSubmit,
      }),
      invalidatesTags: [blackoutTag],
    }),

    deleteLocationBlackout: build.mutation({
      query: (id) => ({
        url: `${RequestRoutes.Blackout}?blackoutId=${id}`,
        headers: headerJson,
        method: 'DELETE',
      }),
      invalidatesTags: [blackoutTag],
    }),

    deletePhysicianBlackout: build.mutation({
      query: (id) => ({
        url: `${RequestRoutes.Blackout}?blackoutId=${id}`,
        headers: headerJson,
        method: 'DELETE',
      }),
      invalidatesTags: [blackoutTag],
    }),
  }),
});

export const {
  useAddPhysicianBlackoutMutation,
  useAddLocationBlackoutMutation,
  useUpdatePhysicianBlackoutMutation,
  useFetchLocationBlackoutsQuery,
  useFetchPhysicianBlackoutsQuery,
  useUpdateLocationBlackoutMutation,
  useDeleteLocationBlackoutMutation,
  useDeletePhysicianBlackoutMutation,
} = blackoutAPI;
